export class UploadFile {
    FileName?: string;
    Location?: string;
    Data?: string;
}